import router from './router'
import store from './store'
import storage from 'store'
import NProgress from 'nprogress' // progress bar
import '@/components/NProgress/nprogress.less' // progress bar custom style
import notification from 'ant-design-vue/es/notification'
import { setDocumentTitle, domTitle } from '@/utils/domUtil'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { i18nRender } from '@/locales'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const allowList = ['login', 'register', '/callback', '/auth-redirect', '/bind'] // no redirect allowList
const loginRoutePath = '/user/login'
const defaultRoutePath = '/index'

// ⭐ 片商相关常量
const FILM_ROLE_KEY = 'film_user'                  // 片商角色 key
const FILM_DEFAULT_ROUTE = '/videoStatistics/videoData' // 片商默认进入的页面（短剧统计 → 短剧）

router.beforeEach((to, from, next) => {
  NProgress.start() // start progress bar
  to.meta && (typeof to.meta.title !== 'undefined' && setDocumentTitle(`${i18nRender(to.meta.title)} - ${domTitle}`))

  const token = storage.get(ACCESS_TOKEN)

  /* has token */
  if (token) {
    // 已登录状态下，访问登录页或根路径的处理
    if (to.path === loginRoutePath || to.path === '/') {
      const roles = store.getters.roles || []
      const isFilmUser = roles.includes(FILM_ROLE_KEY)

      // 如果角色已经有了，并且是片商，就直接进片商默认页
      if (roles.length > 0 && isFilmUser) {
        next({ path: FILM_DEFAULT_ROUTE })
      } else {
        // 其他情况还是进系统首页
        next({ path: defaultRoutePath })
      }
      NProgress.done()
    } else {
      // check login user.roles is null
      if (store.getters.roles.length === 0) {
        // request login userInfo
        store
            .dispatch('GetInfo')
            .then(res => {
              const roles = res.roles || []
              // generate dynamic router
              store.dispatch('GenerateRoutes', { roles }).then(() => {
                router.addRoutes(store.getters.routers)
                // 请求带有 redirect 重定向时，登录自动重定向到该地址
                next({ ...to, replace: true }) // hack方法 确保addRoutes已完成
              })
              /**
               * 提前获取省市区数据
               */
              store.dispatch('getCity')
            })
            .catch(() => {
              notification.error({
                message: '错误',
                description: '请求用户信息失败，请重试'
              })
              // 失败时，获取用户信息失败时，调用登出，来清空历史保留信息
              store.dispatch('Logout').then(() => {
                location.href = '/index'
              })
            })
      } else {
        // ⭐ 这里 roles 已经有值（刷新、菜单跳转等都会走这里）
        const roles = store.getters.roles || []
        const isFilmUser = roles.includes(FILM_ROLE_KEY)

        // 如果是片商，并且访问的是 "/" 或系统首页 "/index"，则强制跳到片商默认页面
        if (
            isFilmUser &&
            (to.path === '/' || to.path === defaultRoutePath) &&
            to.path !== FILM_DEFAULT_ROUTE
        ) {
          next({ path: FILM_DEFAULT_ROUTE })
          NProgress.done()
        } else {
          next()
        }
      }
    }
  } else {
    if (allowList.includes(to.name)) {
      // 在免登录名单，直接进入
      next()
    } else {
      next({ path: loginRoutePath, query: { redirect: to.fullPath } })
      NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
    }
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})
